import { Pagination } from '@/domain/entities/Pagination'
import { FAQ, FAQData } from '@/domain/entities/Faq'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class FAQDataMapper extends BaseResponseMapper {
  public convertFAQFromApi(result: AxiosResponse<any>): FAQ {
    const { data } = result
    return new FAQ(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new FAQData(
            val.id,
            val.question,
            val.answer,
            val.is_active,
            val.created_at,
            val.updated_at
          )
      )
    )
  }
}
